"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appStateSelectFC_1 = __importDefault(require("../../shared/appStateSelectFC"));
const setObjectPropByPath_1 = __importDefault(require("../../shared/setObjectPropByPath"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const AppStateConstants_1 = require("../../types/AppStateConstants");
const callableTriggerEvent = ({ entryVars: { control: controlEntryVar, eventName, }, executeProcesses, functionId, callbacks, store, }) => {
    var _a;
    if (!(0, valueIsString_1.default)(controlEntryVar) && !(0, valueIsRecord_1.default)(controlEntryVar)) {
        executeProcesses(functionId, callbacks.error, 'The control to execute trigger event was not found.');
        return;
    }
    if (!(0, valueIsString_1.default)(eventName)) {
        executeProcesses(functionId, callbacks.error, 'Event name must be a string and is required.');
        return;
    }
    const control = controlEntryVar;
    const flattedControls = (0, appStateSelectFC_1.default)(store.getState());
    let controlId;
    if ((0, valueIsRecord_1.default)(control)) {
        if (!(0, valueIsString_1.default)(control.id)) {
            executeProcesses(functionId, callbacks.error, 'The control to execute trigger event was not found.');
            return;
        }
        controlId = control.id;
    }
    else {
        controlId = control;
    }
    const controlToModify = flattedControls
        ? (_a = flattedControls[controlId]) === null || _a === void 0 ? void 0 : _a.control
        : undefined;
    if (flattedControls && controlToModify) {
        const updatedControl = (0, setObjectPropByPath_1.default)(controlToModify, ['triggeredEvent'], eventName);
        store.dispatch({
            type: AppStateConstants_1.AppStateConstants.BO_UPDATE_CONTROL_BY_ID,
            payload: {
                control: controlToModify,
                dataToUpdate: updatedControl,
            },
        });
    }
    executeProcesses(undefined, callbacks.success);
};
exports.default = callableTriggerEvent;
